
import { defineComponent, SetupContext, ref } from "vue";
import NativeClient from "@/client/native-client";
import {
  DETAIL_ITEM_TYPE,
  DETAIL_ITEM_DATA,
  PANTRY_FOOD_TYPE,
  StockQuantityInfo,
  RegisterPantryPlatePlateInfo,
  PlateInfoData,
  PantryPlateWeightInfo
} from "@/types/pantry";
import PantryDetailDataItem from "./PantryDetailDataItem.vue";
import PantryDetailGraphView from "./PantryDetailGraphView.vue";
export default defineComponent({
  name: "PantryDetailDataView",
  components: {
    PantryDetailDataItem,
    PantryDetailGraphView
  },
  props: {
    type: {
      type: String,
      defalut: ""
    },
    updateDate: {
      type: String,
      defalut: ""
    },
    stockQuantity: {
      type: StockQuantityInfo,
      default: null
    },
    storage: {
      type: String,
      default: ""
    },
    isShowData: {
      type: Boolean,
      defalut: false,
      required: true
    },
    purchaseDate: {
      type: String,
      defalut: ""
    },
    expirationDate: {
      type: String,
      defalut: ""
    },
    notificationDate: {
      type: String,
      defalut: ""
    },
    notificationStock: {
      type: RegisterPantryPlatePlateInfo,
      defalut: null
    },
    plateData: {
      type: PlateInfoData,
      default: null
    }
  },
  setup(props, context: SetupContext) {
    const isShowUpdateDate = () => {
      return props.updateDate != "";
    };
    const getIcon = (itemType: number) => {
      let result = "";
      switch (itemType) {
        case DETAIL_ITEM_TYPE.PURCHASE_DATE:
          result = require("@/assets/images/icon_purchase.png");
          break;
        case DETAIL_ITEM_TYPE.STOCK_QUANTITY:
          result = require("@/assets/images/icon_stock.png");
          break;
        case DETAIL_ITEM_TYPE.EXPIRATION_DATE:
          result = require("@/assets/images/icon_expiration.png");
          break;
        case DETAIL_ITEM_TYPE.STORAGE:
          result = require("@/assets/images/icon_storage.png");
          break;
        case DETAIL_ITEM_TYPE.NOTIFICATION:
          result = require("@/assets/images/icon_notification.png");
          break;
        case DETAIL_ITEM_TYPE.STOCK_NOTIFICATION:
          result = require("@/assets/images/icon_stock_notification.png");
          break;
      }
      return result;
    };
    const getName = (itemType: number) => {
      let result = "";
      switch (itemType) {
        case DETAIL_ITEM_TYPE.PURCHASE_DATE:
          result = DETAIL_ITEM_DATA.PURCHASE_DATE;
          break;
        case DETAIL_ITEM_TYPE.STOCK_QUANTITY:
          if (props.type == PANTRY_FOOD_TYPE.PLATE) {
            result = DETAIL_ITEM_DATA.STOCK_QUANTITY_PLATE;
          } else {
            result = DETAIL_ITEM_DATA.STOCK_QUANTITY;
          }
          break;
        case DETAIL_ITEM_TYPE.EXPIRATION_DATE:
          result = DETAIL_ITEM_DATA.EXPIRATION_DATE;
          break;
        case DETAIL_ITEM_TYPE.STORAGE:
          result = DETAIL_ITEM_DATA.STORAGE;
          break;
        case DETAIL_ITEM_TYPE.NOTIFICATION:
          result = DETAIL_ITEM_DATA.NOTIFICATION;
          break;
        case DETAIL_ITEM_TYPE.STOCK_NOTIFICATION:
          result = DETAIL_ITEM_DATA.STOCK_NOTIFICATION;
          break;
      }
      return result;
    };
    const isShowStockNotification = () => {
      return props.isShowData && props.type == PANTRY_FOOD_TYPE.PLATE;
    };
    const getSettingImage = () => {
      return !props.isShowData
        ? require("@/assets/images/icon_setting_open.png")
        : require("@/assets/images/icon_setting_close.png");
    };
    const onClickShowSetting = () => {
      context.emit("show-data-setting");
    };
    const onChangeValue = (itemType: number) => {
      context.emit("change-value", itemType);
    };
    const isShowArrow = () => {
      return props.type != PANTRY_FOOD_TYPE.FRIDGE;
    };
    const isShowGraph = () => {
      return props.isShowData && props.type == PANTRY_FOOD_TYPE.PLATE;
    };
    const getGraphData = () => {
      NativeClient.sendDebugLog("PantryDetailDataView getGraphData plateData=" + JSON.stringify(props.plateData));
      return props.type == PANTRY_FOOD_TYPE.PLATE &&
        props.plateData &&
        props.plateData.weight
        ? props.plateData.weight
        : null;
    };
    const isShowPlateError = () => {
      let result = false;
      if (
        props.plateData != null &&
        props.plateData.plate != null &&
        props.plateData.plate.errorStatus != null &&
        props.plateData.plate.errorStatus.errorCode != ""
      ) {
        result = true;
      }
      return result;
    };
    const clickQuestion = () => {
      context.emit("show-guide");
    };
    return {
      DETAIL_ITEM_TYPE,
      isShowUpdateDate,
      getIcon,
      getName,
      isShowStockNotification,
      getSettingImage,
      onClickShowSetting,
      onChangeValue,
      isShowArrow,
      isShowGraph,
      getGraphData,
      isShowPlateError,
      clickQuestion
    };
  }
});
